import { View } from "binder"
import { ExecutableViewModel } from "../../executable/executable-viewModel";
import { CallServerViewModel } from "./callServer-viewModel"

export class CallServerView extends View<CallServerViewModel>{
    GetViewUniqueId(): string {
        return "V-6B6576C7-23DA-4810-82B3-A127555B8401"
    }
    loadHtml(): string {
        let element = require('./callServer.html').default;
        let style = require('./callServer.less');
        return element;
    }
    constructor() {
       super();
    }
    public set initializationCode(v: ExecutableViewModel) { this._initializationCode = v; } public get initializationCode(): ExecutableViewModel { return this._initializationCode;} private _initializationCode: ExecutableViewModel;
    public set address(v: string) { this._address = v; } public get address(): string { return this._address;} private _address: string;
    public set settingCode(v: ExecutableViewModel) { this._settingCode = v; } public get settingCode(): ExecutableViewModel { return this._settingCode;} private _settingCode: ExecutableViewModel;
    public set inVariableName(v: string) { this._inVariableName = v; } public get inVariableName(): string { return this._inVariableName;} private _inVariableName: string;
    public set outVariableName(v: string) { this._outVariableName = v; } public get outVariableName(): string { return this._outVariableName;} private _outVariableName: string;
}
